import { Component }       from '@angular/core';
import { ActivatedRoute }  from '@angular/router';
import { Location }        from '@angular/common';
import * as _ from 'lodash';

import { DeveloperService } from '../../services/developers/developer.service';

import { UserDetailComponent } from '../../users/detail/user-detail.component';
import { ProviderService } from '../../services/providers/provider.service';
import { Auth } from '../../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-developer-detail',
  templateUrl: 'developer-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class DeveloperDetailComponent extends UserDetailComponent {

  providers: any[]
  selectedProviderIndex:any
  hasBOUsersPermission:boolean = false;

  constructor(
    protected developerService: DeveloperService,
    protected route: ActivatedRoute,
    protected location: Location,
    protected providerService: ProviderService,
    protected auth: Auth
  ) { super(developerService, route, location); }

  fillObject(): void {
    this.hasBOUsersPermission = this.auth.hasBOUsersPermission();
    if(!this.hasBOUsersPermission){
      $(document).ready (() => {
        var inputs = document.getElementsByTagName('input');
        var selects = document.getElementsByTagName('select');
        Array.from(inputs).forEach((input) => input.setAttribute("disabled",""));
        Array.from(selects).forEach((select) => select.setAttribute("disabled",""));
      })
    }
  }

  getProviders(){
    this.providerService.get().then((response)=>{
      for (var i = 0 ; i<response.length;i++){
        if (response[i].id==this.user.provider.id) this.selectedProviderIndex = i
      }
      this.providers = response
    })
  }

  protected getUpdatedFields(): any {

    let updatedFields = {};
    let self = this;
    _.each(self.updatedUser, function (value: any, key: string) {

      if (key=='provider'){
        if (self.user[key].id!=self.providers[self.selectedProviderIndex].id)
        updatedFields[key] = self.providers[self.selectedProviderIndex].id;
      }
      if (self.user[key] !== value) {
        updatedFields[key] = value;
      }
    });
    return updatedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/developers/detail/developer-detail.component.ts